import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import RankingSection from '@/pages/home/components/RankingSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import IndexSection from '@/pages/home/components/IndexSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import MediaSection from '@/pages/home/components/MediaSection';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <HeroSection />
        <CarouselSection />
        <RankingSection />
        <AboutSection />
        <AppSection />
        <IndexSection />
        <UpdatesSection />
        <CommentsSection />
        <FaqSection />
        <TopicsSection />
        <ContactSection />
        <FeaturesSection />
        <CardsSection />
        <MediaSection />
      </main>

      <Footer />
    </>
  );
}